const BillingValidation = {
  fields: {
    taxid: {
      conditions: [
        {
          expressions: [
            {
              property: "taxid_required",
              operator: "is",
              value: true,
            },
            {
              property: "taxid_enabled",
              operator: "is",
              value: true,
            },
          ],
          logicalOperator: "&&",
        },
      ],
      validations: {
        empty: {
          errorMessageKey: "payment.taxid-not-empty",
        },
        pattern: {
          patternProperty: "taxid_pattern",
          errorMessageKey: "payment.taxid-match-pattern",
        },
      },
    },
    name: {
      conditions: [
        {
          expressions: [
            {
              property: "billing_same_as_shipping",
              operator: "is",
              value: false,
            },
          ],
        },
      ],
      validations: {
        empty: {
          errorMessageKey: "information.name-not-empty",
        },
        pattern: {
          patternValue:
            /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\u4E00-\u9FA5_A-zÀ-ú0-9'.\-\s]+$/,
          errorMessageKey: "information.name-invalid",
        },
      },
    },
    surname: {
      conditions: [
        {
          expressions: [
            {
              property: "billing_same_as_shipping",
              operator: "is",
              value: false,
            },
          ],
        },
      ],
      validations: {
        empty: {
          errorMessageKey: "information.surname-not-empty",
        },
        pattern: {
          patternValue:
            /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\u4E00-\u9FA5_A-zÀ-ú0-9'.\-\s]+$/,
          errorMessageKey: "information.surname-invalid",
        },
      },
    },
    phone: {
      conditions: [
        {
          expressions: [
            {
              property: "no_shipping_required",
              operator: "is",
              value: false,
            },
            {
              property: "billing_same_as_shipping",
              operator: "is",
              value: false,
            },
            {
              property: "phone_required",
              operator: "is",
              value: true,
            },
            {
              property: "phone_enabled",
              operator: "is",
              value: true,
            },
          ],
          logicalOperator: "&&",
        },
        {
          logicalOperator: "||",
        },
        {
          expressions: [
            {
              property: "no_shipping_required",
              operator: "is",
              value: true,
            },
            {
              property: "phone_required",
              operator: "is",
              value: true,
            },
            {
              property: "phone_enabled",
              operator: "is",
              value: true,
            },
          ],
          logicalOperator: "&&",
        },
      ],
      validations: {
        empty: {
          errorMessageKey: "information.phone-not-empty",
        },
        pattern: {
          patternValue: /^\+?[0-9\-()\s]+$/,
          errorMessageKey: "information.phone-only-letters",
        },
      },
    },
    address: {
      conditions: [
        {
          expressions: [
            {
              property: "billing_same_as_shipping",
              operator: "is",
              value: false,
            },
          ],
        },
      ],
      validations: {
        empty: {
          errorMessageKey: "information.address-not-empty",
        },
        pattern: {
          patternValue:
            /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\u4E00-\u9FA5\u4E00-\u9fa5_A-zÀ-ú0-9'.\-\s]+$/,
          errorMessageKey: "information.address-invalid",
        },
      },
    },
    city: {
      conditions: [
        {
          expressions: [
            {
              property: "billing_same_as_shipping",
              operator: "is",
              value: false,
            },
            {
              property: "country",
              operator: "!=",
              value: "CO",
            },
            {
              property: "country",
              operator: "!=",
              value: "PE",
            },
          ],
          logicalOperator: "&&",
        },
      ],
      validations: {
        empty: {
          errorMessageKey: "information.city-not-empty",
        },
        pattern: {
          patternValue:
            /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\u4E00-\u9FA5\u4E00-\u9fa5_A-zÀ-ÿäöüÄÖÜß'\s]+$/,
          errorMessageKey: "information.city-only-letters",
        },
      },
    },
    postal: {
      conditions: [
        {
          expressions: [
            {
              property: "no_shipping_required",
              operator: "is",
              value: false,
            },
            {
              property: "billing_same_as_shipping",
              operator: "is",
              value: false,
            },
            {
              property: "postal_required",
              operator: "is",
              value: true,
            },
            {
              property: "postal_enabled",
              operator: "is",
              value: true,
            },
          ],
          logicalOperator: "&&",
        },
        {
          logicalOperator: "||",
        },
        {
          expressions: [
            {
              property: "no_shipping_required",
              operator: "is",
              value: true,
            },
            {
              property: "postal_required",
              operator: "is",
              value: true,
            },
            {
              property: "postal_enabled",
              operator: "is",
              value: true,
            },
          ],
          logicalOperator: "&&",
        },
      ],
      validations: {
        empty: {
          errorMessageKey: "information.postal-not-empty",
        },
        pattern: {
          patternValue:
            /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\u4E00-\u9FA5\u4E00-\u9fa5_a-zA-Z0-9]+-?\s?[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\u4E00-\u9FA5\u4E00-\u9fa5_a-zA-Z0-9]+$/,
          errorMessageKey: "information.postal-allow-characters",
        },
      },
    },
    country: {
      conditions: [
        {
          expressions: [
            {
              property: "billing_same_as_shipping",
              operator: "is",
              value: false,
            },
          ],
        },
      ],
      validations: {
        empty: {
          errorMessageKey: "information.country-not-empty",
        },
      },
    },
    region: {
      conditions: [
        {
          expressions: [
            {
              property: "billing_same_as_shipping",
              operator: "is",
              value: false,
            },
            {
              property: "regions",
              subproperty: "length",
              operator: ">",
              value: 0,
            },
          ],
          logicalOperator: "&&",
        },
      ],
      validations: {
        empty: {
          errorMessageKey: "information.region-not-empty",
        },
      },
    },
    municipality: {
      conditions: [
        {
          expressions: [
            {
              property: "billing_same_as_shipping",
              operator: "is",
              value: false,
            },
            {
              property: "municipalities",
              subproperty: "length",
              operator: ">",
              value: 0,
            },
          ],
          logicalOperator: "&&",
        },
      ],
      validations: {
        empty: {
          errorMessageKey: "information.municipality-not-empty",
        },
      },
    },
  },
};

export default BillingValidation;
